import { SVGProps } from "react";

const Notification = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="Notification">
    <path
      d="M17.2 14.5H19v1.8H1v-1.8h1.8V8.2a7.2 7.2 0 1 1 14.4 0v6.3Zm-1.8 0V8.2a5.4 5.4 0 1 0-10.8 0v6.3h10.8Zm-8.1 3.6h5.4v1.8H7.3v-1.8Z"
      fill="var(--main-text-primary)"
      stroke="var(--main-bg-surface)"
      strokeWidth={0.8}
    />
  </svg>
)

export default Notification;